<div class="modal-wrapper" *ngIf="showForm" [ngClass]="{'loaded': loaded && loaded['loaded']}">
  <div class="wrapper">
    <div class="under-wrapper" [ngClass]="{'loaded': loaded && loaded['loaded']}" sdClickOutside (clickOutside)="closeModal($event)" #parent
         [parentRef]="parent">
      <div class="img-wrapper cancel" (click)="closeModal($event)">
        <i class="ai ai-cancel"></i>
      </div>
      <div class="tooltip-wrapper">
        <div class="main-title">{{ 'postCodeNeeded' |translate }}</div>
        <div class="row">
          <div class="input-wrapper input-label">
            <input appInputClick appAutofillLabelup class="input" autofocus type="text" placeholder="00-000" [id]="'postcodeInput'"
                   [(ngModel)]="deliveryPostCode" #showDiscountInput>
            <label (click)="showDiscountInput.focus()" class="form-label" [for]="'postcodeInput'"
                   [ngClass]="{'is-Empty':showDiscountInput.value==''}">{{ 'postCode' |translate }}</label>
          </div>
          <div class="button-wrapper">
            <div class="button secondary-button" (click)="saveDeliveryPostCode()">{{ 'save' |translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
